import { useState } from "react";
import { Sentry } from "@/lib/sentry";

// Dev/staging only — three buttons that trigger distinct error shapes so the
// team can verify the end-to-end Sentry pipeline (error → SDK → release tag →
// dashboard). Renders 404 fallback in production builds.

const APP_ENV = (import.meta.env.VITE_ENV ?? import.meta.env.MODE ?? "development") as string;

export default function DebugSentry() {
  const [, setForceRender] = useState(0);

  if (APP_ENV === "production") {
    return (
      <div style={{ padding: 48, fontFamily: "system-ui, -apple-system, sans-serif" }}>
        <h1>404 — Not Found</h1>
      </div>
    );
  }

  const triggerRender = () => {
    setForceRender((n) => n + 1);
    throw new Error("[debug-sentry] intentional render throw — bmc-admin");
  };

  const triggerRejection = () => {
    void Promise.reject(new Error("[debug-sentry] intentional unhandled rejection — bmc-admin"));
  };

  const triggerAsync = () => {
    setTimeout(() => {
      throw new Error("[debug-sentry] intentional async throw — bmc-admin");
    }, 50);
  };

  const triggerManual = () => {
    try {
      throw new Error("[debug-sentry] intentional caught error — bmc-admin");
    } catch (e) {
      Sentry.captureException(e);
    }
  };

  const btnStyle: React.CSSProperties = {
    background: "#E91E8C",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    minWidth: 320,
  };

  return (
    <div style={{ padding: 48, maxWidth: 640, fontFamily: "system-ui, -apple-system, sans-serif" }}>
      <h1 style={{ fontSize: 22, marginBottom: 8 }}>Sentry — debug routes</h1>
      <p style={{ fontSize: 14, color: "#666", marginBottom: 24 }}>
        Environment: <code>{APP_ENV}</code>. Each button triggers a different
        error shape so we can verify the Sentry pipeline. Check the{" "}
        <code>bmc-admin</code> Sentry project after clicking.
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <button style={btnStyle} onClick={triggerRender}>
          1. Render throw — should hit ErrorBoundary fallback
        </button>
        <button style={btnStyle} onClick={triggerRejection}>
          2. Unhandled Promise rejection
        </button>
        <button style={btnStyle} onClick={triggerAsync}>
          3. Async throw (setTimeout) — uncaught
        </button>
        <button style={btnStyle} onClick={triggerManual}>
          4. Manual Sentry.captureException (try/catch)
        </button>
      </div>
    </div>
  );
}
